/** Український номер у вигляді «(068) 080 18 86»; нестандартні номери показуємо як є. */
export function formatPhone(raw) {
    const str = String(raw || "").trim();
    let d = str.replace(/\D/g, "");
    if (d.length === 12 && d.startsWith("380")) d = d.slice(2);
    else if (d.length === 11 && d.startsWith("80")) d = d.slice(1);
    else if (d.length === 9) d = `0${d}`;
    if (d.length !== 10 || d[0] !== "0") return str;
    return `(${d.slice(0, 3)}) ${d.slice(3, 6)} ${d.slice(6, 8)} ${d.slice(8)}`;
}

/** Номер для tel: / копіювання: +380XXXXXXXXX (або цифри як є для нестандартних). */
export function phoneE164(raw) {
    const formatted = formatPhone(raw);
    const d = formatted.replace(/\D/g, "");
    if (/^\(0\d{2}\) \d{3} \d{2} \d{2}$/.test(formatted)) return `+38${d}`;
    return d ? `+${d}` : "";
}

/**
 * Форматування під час введення: будь-який варіант (+380…, 380…, 80…, 0…, 68…, з пробілами/дужками/дефісами)
 * поступово перетворюється на «(068) 080 18 86». Роздільник додається лише перед наступною цифрою,
 * тож Backspace не «застрягає» на дужці чи пробілі. Іноземний номер (+ не 38) лишаємо як введено.
 */
export function formatPhoneInput(raw) {
    const str = String(raw || "");
    const trimmed = str.trim();
    if (trimmed.startsWith("+") && !/^\+\s*3(\s*8)?/.test(trimmed) && trimmed.replace(/\D/g, "").length > 0) {
        return str;
    }
    let d = str.replace(/\D/g, "");
    if (trimmed === "+") return "+";
    // Початок «8…» (як 80…) — чекаємо наступну цифру, щоб не перетворити на «(08…»
    if (d === "8") return "8";
    if (d.startsWith("380")) d = d.slice(2);
    else if (d.startsWith("38") && d.length > 2) d = d.slice(2);
    else if (d === "3" || d === "38") return trimmed.startsWith("+") ? `+${d}` : d;
    else if (d.startsWith("80")) d = d.slice(1);
    if (d && d[0] !== "0") d = `0${d}`;
    d = d.slice(0, 10);
    if (!d) return "";
    let out = `(${d.slice(0, 3)}`;
    if (d.length > 3) out += `) ${d.slice(3, 6)}`;
    if (d.length > 6) out += ` ${d.slice(6, 8)}`;
    if (d.length > 8) out += ` ${d.slice(8, 10)}`;
    return out;
}
